import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryProvider } from './providers/QueryProvider';
import './services/firebase'; // Initialize Firebase
import { reportClientError } from './services/errorReportingService';

// Global crash reporting → dev_error Slack channel (devs only; operators are not
// pinged for client-page errors). Catches async errors + unhandled rejections
// that the ErrorBoundary (render-only) can't. Throttled + never throws.
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    reportClientError({
      source: 'window.onerror',
      message: e?.message || (e?.error && e.error.message),
      stack: e?.error && e.error.stack,
    });
  });
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e?.reason;
    reportClientError({
      source: 'unhandledrejection',
      message: (reason && reason.message) || String(reason),
      stack: reason && reason.stack,
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryProvider>
    <App />
  </QueryProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
